
import React from 'react';

import h from './img/20.png';
import hh from './img/21.jpeg';
import hhh from './img/22.jpg';
import hhhh from './img/23.jpeg';
import hhhhh from './img/24.jpeg';
import hhhhhh from './img/25.png';
import hhhhhhh from './img/26.png';
import hhhhhhhh from './img/27.jpeg';
import hhhhhhhhh from './img/28.jpeg';
import hhhhhhhhhh from './img/29.png';
import hhhhhhhhhhh from './img/30.png';
import hhhhhhhhhhhh from './img/31.jpeg';
import hhhhhhhhhhhhh from './img/32.jpeg';

import './customers.css';

const images = [
  h,
  hhhhhhhhhhh,
  hhh,
  hhhh,
  hhhhhhhhhhhhh,
  hhhhhhh,
  hhhhhhhhhhhh,
  hhhhhh,
  hh,
  hhhhhhhh,
  hhhhhhhhhhhh,
  hhhhhhhhh,
  hhhhh
];

const row1 = images.slice(0, 7);
const row2 = images.slice(7);

const MarqueeRow = ({ images, reverse = false, row }) => {
  return (
    <div
      className={`marquee-container marquee-row-${row}`}
      aria-label={`שורת לקוחות ${row === 'one' ? 'ראשונה' : 'שנייה'}`}
    >
      <div
        className={`marquee-content ${
          reverse ? 'marquee-reverse' : ''
        }`}
      >
        {images.map((imgSrc, index) => (
          <div
            className="marquee-item"
            key={`row-${row}-${index}`}
          >
            <img
              src={imgSrc}
              className="customer-img"
              alt={`לוגו לקוח ${index + 1}`}
              loading="lazy"
              decoding="async"
              draggable="false"
            />
          </div>
        ))}

        {images.map((imgSrc, index) => (
          <div
            className="marquee-item"
            key={`row-${row}-copy-${index}`}
            aria-hidden="true"
          >
            <img
              src={imgSrc}
              className="customer-img"
              alt=""
              loading="lazy"
              decoding="async"
              draggable="false"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export const customers = () => {
  return (
    <section
      className="customers-section"
      aria-label="הלקוחות שלנו"
    >
      <h1 className="customers-seo-heading">
        הלקוחות שלנו
      </h1>

      <p className="customers-seo-description">
        הצצה ללקוחות שבחרו בשירותינו ולמגוון העסקים שאנו גאים לעבוד איתם
      </p>

      <MarqueeRow
        images={row1}
        row="one"
      />

      <MarqueeRow
        images={row2}
        reverse
        row="two"
      />
    </section>
  );
};
